<div class="w-full p-4">
    @if(allProjects.length){
    <div class="flex justify-space-between items-center">
        <div class="w-1/2">
            Showing
            {{ editMode() ? rows().length : uneditRows().length }} of
            {{ allProjects?.length }} projects
        </div>
        <div class="w-1/2 flex items-center my-4 justify-end">
            @if(canEdit() ){
            <button

                [attr.data-uiTarget]="'edit-button'"
                class="rounded-full p-2 mr-2 bg-white hover:bg-dat-blue-100 text-dat-blue-500 border-2 hover:bg-dat-gray-100 col-span-1 md:col-span-3 flex items-center soace-between uppercase"
                (click)="toggleEditMode()"
            >
                <span class="material-symbols-outlined"> edit </span>
            </button>
            } @if(maxProjects() < allProjects.length){
            <button
                [attr.data-uiTarget]="'load-more'"
                class="rounded-full p-2 bg-white mr-2 text-dat-blue-500 hover:bg-dat-blue-100 col-span-1 md:col-span-3 flex items-center soace-between uppercase"
                alt="Add More Rows"
                (click)="loadMore()"
            >
                <span class="material-symbols-outlined inline-block">
                    variable_add
                </span>
            </button>
            }
            <button
                [attr.data-uiTarget]="'export'"
                class="rounded-full p-2 bg-dat-blue-600 text-white hover:bg-dat-blue-700 col-span-1 md:col-span-3 flex items-center soace-between uppercase"
                (click)="export()"
            >
                <span class="material-symbols-outlined inline-block">
                    download
                </span>
            </button>
        </div>
    </div>
    @if(editMode()){
    <iq-controls-dashboard
        [id]="headerControls.id"
        [controls]="headerControls.controls"
        [containerClasses]="headerControls.containerClasses ?? {}"
    ></iq-controls-dashboard>

    @for (row of rows(); track row.id) {
    <iq-controls-dashboard
        [id]="row.id"
        [controls]="row.controls"
        (submitted)="onSubmit(row.id, $event)"
        [containerClasses]="row.containerClasses ?? {}"
    ></iq-controls-dashboard>
    } } @else {
    <table class="w-full">
        <tr class="grid grid-cols-7 text-left py-2">
            @for(control of headerControls.controls; track control.id) {
            @if(control.type !== 'Submit'){
            <th>
                <iq-builder-label [label]="control.label"></iq-builder-label>
            </th>
            } }
        </tr>
        @for (row of uneditRows(); track row.id) {
        <tr class="grid grid-cols-7 truncate py-2">
            @for(col of row.cols; track col.id ) {
            <td>
                <iq-builder-label
                    [shouldTruncate]="true"
                    [label]="col.label"
                ></iq-builder-label>
            </td>
            }
        </tr>
        }
    </table>
    } } @else { No Projects... }
</div>
